const BACKEND_URL = "https://crmapi.prowesserp.in/api/employee/";
// const BACKEND_URL = "https://localhost:7034/api/employee/";

const APP_CONFIG = {
    BACKEND_URL,
};

export default APP_CONFIG;
